/**
 * BypassGo branded ticket icon — replaces lucide's <Ticket/> wherever the
 * design calls for the custom illustration ("hand pulling a ticket #3 in
 * blue"). Used in marketing/hero places (landing, walkthrough, header
 * pills, ticket details) — small inline lucide icons remain as-is to
 * preserve alignment with surrounding text icons.
 *
 * Props mimic a subset of lucide's API (`size`, `className`) so it can be
 * dropped in as a replacement without ceremony.
 */
export default function BypassTicketIcon({ size = 24, className = "", alt = "Ticket" }) {
  return (
    <img
      src="/ticket-icon-blue.png"
      alt={alt}
      width={size}
      height={size}
      className={`inline-block object-contain align-middle ${className}`}
      style={{ width: size, height: size }}
      data-testid="bypass-ticket-icon"
      draggable={false}
    />
  );
}
